export const ModuleConstants = {
    ACCOUNT: "account",
    JOB: "job",
    CANDIDATE: "candidate",
}